import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers';

import React, { useState } from 'react';
import { IDatePicker } from './interfaces';

export const DatePicker: React.FC<IDatePicker> = ({
  label,
  selectedDate,
  error,
  errorMessage,
  helperMessage,
  onChange,
  disabled,
  disableFuture,
  disablePast,
  minDate,
  maxDate,
  required = false,
}): JSX.Element => {
  const [showDialog, setShowDialog] = useState<boolean>(false);

  return (
    <MuiDatePicker
      label={label}
      open={showDialog}
      onClose={() => setShowDialog(false)}
      value={selectedDate}
      onChange={(date) => onChange(date)}
      disabled={disabled}
      disableFuture={disableFuture}
      disablePast={disablePast}
      minDate={minDate}
      maxDate={maxDate}
      slotProps={{
        textField: {
          required: required,
          size: 'small',
          InputProps: {
            required: required,
            readOnly: true,
            onClick: () => setShowDialog(true),
          },
          error: error,
          helperText: error ? errorMessage : helperMessage,
          sx: {
            fontSize: '0.9rem',
            input: {
              fontSize: '0.9rem',
            },
            '& .MuiSvgIcon-root': {
              fontSize: '16px',
            },
          },
        },
      }}
    />
  );
};
